import { render, staticRenderFns } from "./bindAdvertisers.vue?vue&type=template&id=7c4bb51f&scoped=true"
import script from "./bindAdvertisers.vue?vue&type=script&lang=js"
export * from "./bindAdvertisers.vue?vue&type=script&lang=js"
import style0 from "./bindAdvertisers.vue?vue&type=style&index=0&id=7c4bb51f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4bb51f",
  null
  
)

export default component.exports